import { initialState } from './reducer';

export function getSLOFilterQuery(state: typeof initialState['slo']) {
  return `${state.showDrafts ? '' : '&isDraft=false'}${
    state.hasBreachStatusOnly ? '&hasBreachStatusOnly=true' : ''
  }${state.hasQualityIssuesOnly ? '&hasQualityIssuesOnly=true' : ''}`;
}
